//Interview Details
export const BASE_INTERVIEWS = "/api/interview";